import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Shortcut } from 'video-react';
import classnames from 'classnames';
import memoize from "memoize-one";

import AnimationMarkerForm from './AnimationMarkerForm';
import AnimationMarkersInPlayer from './AnimationMarkersInPlayer';
import MarkShape from './MarkShape';
import PolyLineSvg from "./PolyLineSvg";
import { styles } from "../util/styleDrawComponent";
import {getStyleOfSize} from "../util/getStyleofSize";
import YouTube from 'react-youtube';
import apiClient from '../util/api-client';
import Loadable from 'react-loading-overlay';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AnimationMarkerLine from './AnimationMarkerLine';
import AnimationCommentsPane from './AnimationCommentsPane';
import YouTubeControls from './YoutubeControls';
import { fetchHeightHeader } from '../shared';
import CommentDetail from './CommentDetail';
import AnimationMarkerPeriod from './AnimationMarkerPeriod';
import { COMMENT_BOX_OPENED_EVENT, createCommentBoxSyncId, announceCommentBoxOpened } from '../util/animation-marker';
const markersVisibilities = ['all', 'circle', 'none'];
const showSVGIndex = 1000;
const hideSVGIndex = 0;

export default class ShowEmbedVideos extends Component {
  constructor(props) {
    super();
    const { baseURL } = props;
    this.state = {
      isMarking: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      shouldShowForm: false,
      markersVisibility: 'all',
      currentTime: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      zIndexSvg: hideSVGIndex,
      penConfirmModal: null,
      listItemSvg: [],
      currentItemSvg: null,
      settingDraw: {
        color: "black",
        lineWidth: 3,
      },
      isLargeScreen: true,
      currentCanvasWidth: 0,
      currentCanvasHeight: 0,
      isShowControlBar: false,
      currentHeight: 0,
      currentWidth: 0,
      player: null,
      loadingText: null,
      isLoading: false,
      isShowModalNotCompareVersion: false,
      totalDuration: 0,
      periodRange: null,
      showPeriodRange: [],
      commentNumber: null,
      isMobileFullScreen: false,
    };
    this.apiClient = apiClient({ baseURL: baseURL });

    this.showSeekBar = this.showSeekBar.bind(this);
    this.hintSeekBar = this.hintSeekBar.bind(this);
    this.playerContainerRef = React.createRef();
    this.commentBoxSyncId = createCommentBoxSyncId('show-embed-video');
  }

  startLoading = loadingText => {
    this.setState({ loadingText, isLoading: true });
  }
  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.removeEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
    }
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.addEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);

    this.reset();
    var width = this.elementRef ? this.elementRef.offsetWidth : document.getElementById("animation-player").offsetWidth;
    var height = this.elementRef ? this.elementRef.offsetHeight : document.getElementById("animation-player").offsetHeight;

    this.setState({
      canvasWidth: width,
      canvasHeight: height,
      currentCanvasWidth: width,
      currentCanvasHeight: height,
    });
  }
  update = () => {
    let width = this.elementRef ? this.elementRef.offsetWidth : document.getElementById("animation-player").offsetWidth;
    let height = this.elementRef ? this.elementRef.offsetHeight : document.getElementById("animation-player").offsetHeight;

    if (width !== this.state.canvasWidth) {
      this.setState(
        {
          canvasWidth: width,
          canvasHeight: height,
          listItemSvg: [],
        },
        () => {
          this.ctx = this.canvas.getContext("2d");
          this.ctx.clearRect(
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
          this.ctx.drawImage(
            this.player.video.video,
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.seekTime !== prevProps.seekTime && this.props.seekTime != null) {
      if (this.state.player && this.state.player.pauseVideo) {
        this.state.player.pauseVideo();
        this.seekTo(this.props.seekTime);
        if (this.props.onSeeked) this.props.onSeeked();
      }
    }
  }

  handleCommentBoxOpened = (event) => {
    if (event.detail?.sourceId === this.commentBoxSyncId) return;

    this.setState({
      shouldShowForm: false,
      isMarking: false,
      showPeriodRange: [],
      periodRange: null,
    });
  }

  openMarkerForm = (nextState = {}, callback) => {
    this.props.updateSelectedMarker(null);
    announceCommentBoxOpened(this.commentBoxSyncId);
    this.setState({
      shouldShowForm: true,
      isMarking: false,
      ...nextState,
    }, callback);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.settingDraw != this.state.settingDraw) {
      this.setState({
        settingDraw: newProps.settingDraw,
      });
    }
  }
  mouseRelativeXY(event) {
    return this.relativeXY(event.clientX, event.clientY);
  }
  mouseRelativeXYDraw(event) {
    return this.relativeXY(
      event.nativeEvent.clientX,
      event.nativeEvent.clientY
    );
  }
  touchRelativeXY(event) {
    return this.relativeXY(event.touches[0].clientX, event.touches[0].clientY);
  }
  relativeXY(eventX, eventY) {
    const player = this.player
    const playerRect = findDOMNode(player).getBoundingClientRect();
    return [
      (eventX - playerRect.left) / playerRect.width * 10000,
      (eventY - playerRect.top) / playerRect.height * 10000,
    ];
  }
  startMark = ({ x, y }) => {
    if (!this.props.isCommentMode) return;
    // [2026-06-29] ❹ ペンモード中はテキストの仮マーカー（赤丸）を作らない＝根っこで止める
    if (this.props.is_show_draw_component) return;
    if (this.state.isMobileFullScreen) return;
    this.state.player.pauseVideo();
    const currentTime = this.state.player.getCurrentTime();
    const duration = this.state.player.getDuration();

    if (this.props.onVideoClicked) {
      this.props.onVideoClicked(currentTime, duration);
    }

    this.setState({
      isMarking: true,
      shouldShowForm: false,
      startX: x,
      startY: y,
      currentX: x,
      currentY: y,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      currentTime,
    });
  }
  moveMark = ({ x, y }) => {
    const { isMarking, startX, startY, isMobileFullScreen } = this.state;
    if (isMobileFullScreen) return;
    if (!isMarking) return;
    const { max, abs } = Math;
    const distance = max(abs(x - startX), abs(y - startY));
    distance > 10 && startX < x && startY < y
      ? this.setState({
        currentWidth: max(x - startX, 0),
        currentHeight: max(y - startY, 0),
        currentShape: 'rect',
      })
      : this.setState({
        currentWidth: 0,
        currentHeight: 0,
        currentShape: 'point',
      })
  }
  // ダブルクリック判定用
  _lastTapTime = 0;
  _DOUBLE_TAP_MS = 300;

  _showTapHint = () => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = 'ダブルクリックするとコメントモードに切り替わります';
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        // youtube-controls-wrapperではなく、より大きな親コンテナを使う
        const el = root
          ? root.closest('.wrap-animation-preview') || root
          : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.left = (rect.left + rect.width / 2) + 'px';
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.transform = 'translate(-50%, -50%)';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
      toast.style.transform = 'translate(-50%, -50%)';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  _showModeToast = (text) => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        // youtube-controls-wrapperではなく、より大きな親コンテナを使う
        const el = root
          ? root.closest('.wrap-animation-preview') || root
          : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.left = (rect.left + rect.width / 2) + 'px';
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.transform = 'translate(-50%, -50%)';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
      toast.style.transform = 'translate(-50%, -50%)';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  _showCommentMode = () => {
    this._doubleActivatedAt = Date.now();
    this._doubleConfirmed = true;
    this._justEnteredCommentMode = true;
    if (!this._preventScrollFn) {
      this._preventScrollFn = (e) => { e.preventDefault(); };
    }
    document.addEventListener('touchmove', this._preventScrollFn, { passive: false });
    if (this.props.onEnterCommentMode) this.props.onEnterCommentMode();
  };

  _hideCommentMode = () => {
    if (this._preventScrollFn) {
      document.removeEventListener('touchmove', this._preventScrollFn, { passive: false });
    }
    this._doubleActivatedAt = 0;
    this._doubleConfirmed = false;
    if (this.props.onExitCommentMode) this.props.onExitCommentMode();
  };

  endMark = (event) => {
    if (!this.props.isCommentMode) return;
    if (this._justEnteredCommentMode) {
      this._justEnteredCommentMode = false;
      return;
    }
    if(!this.state.isMarking) return
    if (this.state.isMobileFullScreen) return;
    event.stopPropagation();
    event.preventDefault();
    const { currentAnimationId, animationSelectCurrent, toggleShowModalInputInfoOfNotLogin, isInputInfoMationOfNotLogin } = this.props;
    this.setState({ isMarking: false });
    if (currentAnimationId === animationSelectCurrent) {
      if (gon.is_login || isInputInfoMationOfNotLogin) {
        if (this.props.isOpenNouislider && !this.state.periodRange) {
          Popup.confirm(`範囲の指定が1ヶ所のみです。<br>範囲指定を終了し、コメントを入力しますか？`, {
            confirmText: 'OK',
            success: () => {
              this.props.closeNouislider();
              this.openMarkerForm({ showPeriodRange: [] });
            },
            cancel: () => {
              this.setState({ shouldShowForm: false, showPeriodRange: [], isMarking: false });
            }
          });
        } else {
          this.openMarkerForm({ showPeriodRange: [] });
        }
      } else {
        toggleShowModalInputInfoOfNotLogin();
      }
      this.disableMmount();
    }
  };

  isTouchInsidePlayer = (event) => {
    if (!event || !event.touches || !event.touches[0] || !this.player) return true;
    const playerRect = findDOMNode(this.player).getBoundingClientRect();
    const touchX = event.touches[0].clientX;
    const touchY = event.touches[0].clientY;
    return (
      touchX >= playerRect.left &&
      touchX <= playerRect.right && 
      touchY >= playerRect.top &&
      touchY <= playerRect.bottom
    );
  }
  getStyleOnMode = () => {
    const {onMode} = this.props;
    let style = {};
    onMode ? style = {
      top: 0,
      bottom: "unset"
    } : style = {
      top: 0,
      bottom: 0
    };
    return style;
  }
  disableMmount(e = "") {
    var menus = document.querySelectorAll(".show-mark-shape");
    menus = [].slice.call(menus);
    menus.forEach(function (element) {
      element.style.pointerEvents = e;
    });
  }
  renderOverlay() {
    return (
      <div
        className="overlay"
        style={{
          ...this.getStyleOnMode(),
          pointerEvents: this.state.isMobileFullScreen ? 'none' : 'auto'
        }}
        onMouseDown={(event) => {
          if (this._touchHandled) return;
          event.stopPropagation();
          event.preventDefault();
          const now = Date.now();
          const delta = now - this._lastTapTime;
          this._lastTapTime = now;
          if (delta < this._DOUBLE_TAP_MS && delta > 0) {
            this._lastTapTime = 0;
            if (!this.props.isCommentMode) {
              this._showCommentMode();
              this._showModeToast('コメントモードに切り替わりました');
            }
            return;
          }
          if (!this.props.isCommentMode) {
            this._showTapHint();
            return;
          }
          this.disableMmount("none");
          const [x, y] = this.mouseRelativeXY(event);
          this.startMark({ x, y });
        }}
        onTouchStart={(event) => {
          this._touchHandled = true;
          setTimeout(() => { this._touchHandled = false; }, 500);
          event.stopPropagation();
          event.preventDefault();
          this.setOption();
          const now = Date.now();
          const delta = now - this._lastTapTime;
          this._lastTapTime = now;
          if (delta < this._DOUBLE_TAP_MS && delta > 0) {
            this._lastTapTime = 0;
            if (!this.props.isCommentMode) {
              this._showCommentMode();
              this._showModeToast('コメントモードに切り替わりました');
            }
            return;
          }
          if (!this.props.isCommentMode) {
            this._showTapHint();
            return;
          }
          const [x, y] = this.touchRelativeXY(event);
          this.startMark({ x, y });
        }}
        onMouseMove={(event) => {
          event.stopPropagation();
          event.preventDefault();
          const [x, y] = this.mouseRelativeXY(event);
          this.moveMark({ x, y });
        }}
        onTouchMove={(event) => {
          event.stopPropagation();
          event.preventDefault();
          if (!this.isTouchInsidePlayer(event)) {
            this.endMark(event);
            return;
          }
          const [x, y] = this.touchRelativeXY(event);
          this.moveMark({ x, y });
        }}
        onMouseUp={this.endMark}
        onTouchEnd={this.endMark}
        onTouchCancel={this.endMark}
        onClick={this.setOption}
      ></div>
    );
  }
  openPeriod = (periodRange) => {
    if (this.state.startX === 0 &&
        this.state.startY === 0 &&
        this.state.currentX === 0 &&
        this.state.currentY === 0) {
      this.openMarkerForm({
        periodRange: periodRange,
        startX: 1000,
        startY: 1000,
        currentX: 1000,
        currentY: 1000
      });
    } else {
      this.openMarkerForm({
        showPeriodRange: [],
        periodRange: periodRange,
      });
    }
  }
  onSubmitMarkerForm = (body, files, editorSetting) => {
    const { onSubmitMarkerForm } = this.props;
    const {
      currentX: x,
      currentY: y,
      currentWidth: width,
      currentHeight: height,
      currentShape: shape,
      currentTime: time,
      periodRange
    } = this.state;
    return onSubmitMarkerForm({
      body,
      x,
      y,
      width,
      height,
      shape,
      time,
      files,
      editorSetting,
      periodRange
    }).then(() =>
      this.setState({
        shouldShowForm: false,
        periodRange: null,
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        currentShape: 'point',
        listItemSvg: [],
        isDel: false,
        isDraw: false,
        zIndexSvg: showSVGIndex,
      })
    );
  };
  onCloseMarkerForm = () => {
    this.setState(
      {
        shouldShowForm: false,
      },
      () => {
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
        this.ctx.drawImage(
          this.player.video.video,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      }
    );
  };
  activeMarkers() {
    const { markers, selectedMarker } = this.props;
    const currentTime = this.state.currentTime ? this.state.currentTime : 0
    // ★FIX(20260405): markerが選択されている場合はそのmarkerのみ表示
    if (selectedMarker && selectedMarker.id != null) {
      const targetId = selectedMarker.isComment
        ? selectedMarker.id : selectedMarker.parent_id;
      return markers.filter(_ => _.id === targetId);
    }
    // 未選択時（動画再生中など）：従来通り±1秒のフィルター
    return markers.filter(_ =>
      (currentTime - 1 <= _.seek_time && _.seek_time <= currentTime + 1) ||
        (_.period_end > 0 && _.seek_time <= currentTime && currentTime - 1 <= _.period_end)
    );
  }
  onTimeUpdate = () => {
    const currentTime = this.state.player ? this.state.player.getCurrentTime() : 0
    const {is_capture_video_youtube} = this.props;
    if (this.state.player && (!is_capture_video_youtube || currentTime !== this.state.currentTime)) {
      this.setState({
        currentTime: currentTime
      });
    }
  }
  seekTo(time) {
    if (this.state.player) {
      this.state.player.seekTo(time);
    }
  }
  onClickMarkersToggler = () => {
    const currentIndex = markersVisibilities.indexOf(this.state.markersVisibility);
    const nextIndex = (currentIndex + 1) < markersVisibilities.length ? currentIndex + 1 : 0;
    this.setState({ markersVisibility: markersVisibilities[nextIndex] });
  }
  refCallback = element => {
    const { getHeightAnimaiton } =this.props
    if (element && getHeightAnimaiton) {
      this.elementRef = element;
      getHeightAnimaiton(element.getBoundingClientRect().height);
    }
  };

  showSeekBar(){
    const { mobile } = this.props
    if(mobile) return
  }

  hintSeekBar(){
    const { mobile } = this.props
    if(mobile) return
  }

  showSeekBarMobile(){
    const { mobile } = this.props
    if(!mobile)
      return
    if (element && playButton){
      this.showSeekBar();
    } else if (playButton){
      playButton.style.display = 'none';
    }
  }

  async draw(e) {
    this.state.player.pauseVideo();
    const currentTime = this.state.player.getCurrentTime()
    this.state.player.seekTo(currentTime, true)
    const { baseURL, currentAnimation, isShowDra, is_show_draw_component, changeIsCaptureVideoYoutube } = this.props;
    if (is_show_draw_component) {
      this.setState(
        {
          isDel: false,
          shouldShowForm: false,
          // [2026-06-29] ❹ YouTubeもペン切替時にテキストの仮マーカーを片付ける
          isMarking: false,
          currentX: 0, currentY: 0,
          currentWidth: 0, currentHeight: 0,
          currentShape: 'point',
          startX: 0, startY: 0,
        },
        () => {
          this.setState(
            {
              canvasHeight: this.state.currentCanvasHeight,
              canvasWidth: this.state.currentCanvasWidth,
            },
          );
        }
      );
      this.setState({
        zIndexSvg: showSVGIndex,
      });
      return
    }
    // 新仕様: YouTubeも他のメディアと同様にペンモードを開始する
    // サーバーサイドスクリーンショットは不要
    this.setState(
      {
        isDel: false,
        shouldShowForm: false,
      },
      () => {
        this.setState(
          {
            canvasHeight: this.state.currentCanvasHeight,
            canvasWidth: this.state.currentCanvasWidth,
          },
        );
      }
    );
    this.setState({
      zIndexSvg: showSVGIndex,
    });
  }

  eraser() {
    this.setState({
      isDel: true,
    });
  }

  capture(e) {
    if (this.drawSvg) this.drawSvg.closest('#animation-player') && (this.drawSvg.closest('#animation-player').style["overflow"] = 'unset');
    this.state.player.pauseVideo();
    const currentTime = this.state.player
      ? this.state.player.getCurrentTime()
      : 0;
    const fileDrawName = `draw-video-image-${moment.now()}`;
    const files = [];
    var svgURL = new XMLSerializer().serializeToString(this.svg);
    const canvas = this.canvas;
    const context = canvas.getContext("2d");
    var img = new Image();
    img.onload = async () => {
      if (this.canvas) this.canvas.style.zIndex = '0';
      // ① YouTube動画フレームを背景として描画
      try {
        const frameDataUrl = await this.captureVideoYoutube();
        if (!frameDataUrl) {
          // キャプチャ失敗時は保存中止（SVGだけの黒背景画像を添付しないため）
          return;
        }
        await new Promise((resolve) => {
          const bgImg = new Image();
          bgImg.onload = () => {
            context.drawImage(bgImg, 0, 0, this.state.canvasWidth, this.state.canvasHeight);
            resolve();
          };
          bgImg.onerror = () => resolve();
          bgImg.crossOrigin = "anonymous";
          bgImg.src = frameDataUrl;
        });
      } catch (e) {
        // エラー時も保存中止
        return;
      }
      // ② SVGペン描画を重ねる（既存処理）
      context.drawImage(
        img,
        0,
        0,
        this.state.canvasWidth,
        this.state.canvasHeight
      );
      var imageSrc = this.canvas.toDataURL();
      const { listItemSvg } = this.state;
      if (listItemSvg.length === 0) {
        return;
      } else {
        const { listItemSvg } = this.state;
        const target = this.state.currentItemSvg || listItemSvg[0]
           const arr = target.capturePoint.split(",");
        const convertArr = arr[1].trim().split(" ");
        const markPointCaptureY = Number(convertArr[0]);
        const markPointCaptureX = Number(convertArr[1]);
        this.setState({
          currentX: markPointCaptureX,
          currentY: markPointCaptureY,
        });
      }
      this.urltoFile(imageSrc, fileDrawName, "image/png").then((file) => {
        files.push(file);
        this.openMarkerForm(
          {
            currentShape: "draw",
            currentTime: currentTime,
          },
          () => {
            this.makerForm.onFileChange(null, files);
          }
        );
      });
    };
    img.src = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(svgURL);
  }

  async captureVideoYoutube() {
    const { currentAnimation } = this.props;
    const currentTime = this.state.player
      ? this.state.player.getCurrentTime()
      : 0;
    this.startLoading('Now screenshot... ');

    // 10秒経過したらローディングテキストを切替（広告待ちの可能性が高いため）
    const adWaitTimer = setTimeout(() => {
      if (this.state.isLoading) {
        this.setState({
          loadingText: 'YouTube広告が終了するまでスクリーンショットを待っている状態です。'
        });
      }
    }, 10000);

    try {
      const response = await this.apiClient.post(
        `animations/screen_shot_youtube?id=${currentAnimation.id}&time=${currentTime}`
      );
      clearTimeout(adWaitTimer);

      // success: false の場合（広告タイムアウト・キャプチャ失敗等）
      if (response.data && response.data.success === false) {
        Popup.alert('YouTube広告が終わらないため、キャプチャに失敗しました。<br>少し時間をおいてから、もう一度お試しください。', '', '', {kind: 'akaire'});
        return null;
      }

      return response.data.image;
    } catch (error) {
      clearTimeout(adWaitTimer);
      console.error('[captureVideoYoutube] Error:', error);
      Popup.alert('スクリーンショットの取得に失敗しました。<br>もう一度お試しください。', '', '', {kind: 'akaire'});
      return null;
    } finally {
      clearTimeout(adWaitTimer);
      this.endLoading();
    }
  }

  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  deleteAllDraw() {
    this.setState({
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
      isLargeScreen: true,
    });
  }

  reset() {
    this.setState({
      isDraw: false,
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
      isLargeScreen: true,
    });
    this.ctx = this.canvas.getContext("2d");
    this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
  }

  disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  enableScroll() {
    window.onscroll = function() {};
  }

  onMouseDown(event, isMobile) {
    if (this.state.isMobileFullScreen) return;
    if (this.state.player) this.state.player.pauseVideo();
    if (isMobile) {
      if (this.drawSvg) this.drawSvg.closest('#animation-player') && (this.drawSvg.closest('#animation-player').style["overflow"] = "hidden");
      document.body.style.overflow = "hidden";
    }
    if (!this.state.isDraw && !this.state.isDel) {
      this.setState({
        isDraw: true,
      });
      var newItem = {
        id: Date.now(),
        points: "",
        color: this.state.settingDraw.color,
        lineWidth: this.state.settingDraw.lineWidth,
        capturePoint: "",
      };
      if (!isMobile) {
        var [x, y] = this.mouseRelativeXYDraw(event);
        newItem.capturePoint = ` , ${y} ${x}`;
      } else {
        var [x, y] = this.touchRelativeXY(event);
        newItem.capturePoint = ` , ${y} ${x}`;
        this.disableScroll();
      }
      this.setState({
        listItemSvg: [...this.state.listItemSvg, newItem],
        currentItemSvg: newItem,
      });
    }
  }

  onMouseMove = (event, isMobile) => {
    if (this.state.isMobileFullScreen) return;
    if (!this.state.isDraw) return;
    var item = document.getElementById(this.state.currentItemSvg.id);
    if (!item) return;
    var points = item.getAttribute("points") || "";
    var capturePoint = item.getAttribute("capturePoint") || "";
    const iframeRect = this.playerContainerRef.getBoundingClientRect();
    const { currentCanvasWidth, currentCanvasHeight } = this.state;
    let xh, yh, x, y;
    if (isMobile) {
      xh = ((event.clientX - iframeRect.left) * currentCanvasWidth / iframeRect.width).toFixed();
      yh = ((event.clientY - iframeRect.top) * currentCanvasHeight / iframeRect.height).toFixed();
      [x, y] = this.mouseRelativeXYDraw(event);
    } else {
      xh = ((event.touches[0].clientX - iframeRect.left) * currentCanvasWidth / iframeRect.width).toFixed();
      yh = ((event.touches[0].clientY - iframeRect.top) * currentCanvasHeight / iframeRect.height).toFixed();
      [x, y] = this.touchRelativeXY(event);
    }
    points += ` ${xh}, ${yh}`;
    capturePoint += ` ${x}, ${y}`;
    item.setAttribute("points", points);
    item.setAttribute("capturePoint", capturePoint);
    const itemInList = this.state.currentItemSvg;
    if (itemInList) {
      itemInList.points = points;
      itemInList.capturePoint = capturePoint;
      itemInList.currentPoints = points;
      itemInList.currentCapturePoint = capturePoint;
    }
  };

  onMouseUp() {
    document.body.style.overflow = "auto";
    const styleOverflow = this.state.shouldShowForm ? 'unset' : 'hidden';
    if (this.drawSvg) this.drawSvg.closest('#animation-player') && (this.drawSvg.closest('#animation-player').style["overflow"] = styleOverflow);
    if (this.state.isDraw) {
      this.setState({
        isDraw: false,
      });
      this.enableScroll()
    }
  }

  onItemMouseOver(event) {
    const { mobile } = this.props;
    const polyWidht = event.target.getBBox().width;
    const polyHeight = event.target.getBBox().height;
    if (!this.state.isDraw && this.state.isDel) {
      if (!mobile) {
        event.target.setAttribute("stroke-dasharray", "5 5");
      }
      if (polyWidht <= 35 && polyHeight <= 35) {
        let id = event.target.getAttribute("id");
        let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
        this.setState({
          listItemSvg: newLists,
        });
      }
    }
  }

  onItemMouseLeave(event) {
    if (!this.state.isDraw && this.state.isDel) {
      event.target.setAttribute("stroke-dasharray", "");
    }
  }

  onChangeFullscreen(isFullscreen) {
    this.setState({ isMobileFullScreen: isFullscreen });
  }

  onDelete(event) {
    if (!this.state.isDraw && this.state.isDel) {
      let id = event.target.getAttribute("id");
      let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
      this.setState({
        listItemSvg: newLists,
      });
    }
  }

  onReadyVideoEmbed(event) {
    const { mobile } = this.props;
    const player = event.target;
    const iframe = player?.getIframe?.();

    if (iframe) {
      this.configureNativeFullscreenIframe(iframe);
      iframe.style.pointerEvents = 'none';
      iframe.setAttribute('tabindex', '-1');
      if (iframe.parentElement) {
        iframe.parentElement.style.pointerEvents = 'none';
      }
    }

    this.setState({ totalDuration: player.getDuration(), player: player }, () => {
      if (this.timeUpdateInterval) clearInterval(this.timeUpdateInterval);
      this.timeUpdateInterval = setInterval(this.onTimeUpdate, 100);
      if (!mobile) {
        player.playVideo();
      }
    });
  }

  configureNativeFullscreenIframe = (iframe) => {
    if (!iframe) return;

    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('webkitallowfullscreen', 'true');
    iframe.setAttribute('mozallowfullscreen', 'true');

    const allow = iframe.getAttribute('allow');
    if (!allow) {
      iframe.setAttribute('allow', 'autoplay; fullscreen');
    } else {
      const nextAllow = allow.includes('fullscreen') ? allow : `${allow}; fullscreen`;
      iframe.setAttribute('allow', nextAllow.includes('autoplay') ? nextAllow : `${nextAllow}; autoplay`);
    }
  }

  // function changed video player state
  changeStateEmbedVideo(event) {
  }

  YouTubeGetID(url) {
    if (url.includes('?v=')) {
      return url.split('?v=')[1].split('&')[0]
    } else if (url.includes('&v=')) {
      return url.split('&v=')[1].split('&')[0]
    } else {
      let regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      return regex.exec(url)[3];
    }
  }

  setOption = () => {
    const { currentAnimationId, animationSelectCurrent } = this.props;
    if (currentAnimationId !== animationSelectCurrent) {
      this.fetchCurrentAnimation()
    }
  }

  handleOutsideClick = (e) => {
    if (!this.nodeModalVersion.contains(e.target)) {
      this.setOption();
    }
  };

  pauseVideo = () => {
    this.state.player.pauseVideo();
  }

  checkPenBeforeAction = (onConfirm) => {
    const { listItemSvg } = this.state;
    if (!listItemSvg || listItemSvg.length === 0) {
      onConfirm();
      return;
    }
    this.setState({ penConfirmModal: {} });
  };

  penConfirmSave = () => {
    this.setState({ penConfirmModal: null });
    this.capture();
  };

  penConfirmDiscard = () => {
    this.setState({
      listItemSvg: [],
      isDel: false,
      isDraw: false,
      shouldShowForm: false,
      penConfirmModal: null,
    });
  };

  penConfirmCancel = () => {
    this.setState({ penConfirmModal: null });
  };

  closeAnimationMarkerForm = () => {
    this.setState({
      shouldShowForm: false,
      periodRange: null,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentShape: 'point',
      showPeriodRange: [],
    })
    if (this.canvas) {
      const ctx = this.canvas.getContext("2d");
      ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
      this.canvas.style.zIndex = '';
    }
    if (this.props.isOpenNouislider) {
      this.props.updateIsOpenNouislider()
    }
  }

  fetchCurrentAnimation = () => {
    const { setCurrentAnimation } = this.props;
    this.setState({ isShowModalNotCompareVersion: false }, () => setCurrentAnimation())
  }

  setPeriodRangeWhenClickTimeLine = (periodRange, number_comment) => {
    this.setState({ showPeriodRange: periodRange, commentNumber: number_comment })
  }

  setShowPeriodRangeFromProp = memoize(
    (showPeriodRangeProp) => {
      this.setState({ showPeriodRange: showPeriodRangeProp })
    }
  );

  handlePlaybackRateChange = (rate) => {
    this.state.player.setPlaybackRate(rate);
  }

  render() {
    const { src, downloadUrl, currentUserId, animationMarkerCreationPath, markers, markerCreatable, onClickDownloadButton,
      mobile, onMarkerUpdationCalled, updateMakerShow, role, owner, user, scaleImage, currentAnimation, is_show_draw_component,
      animationSelectCurrent, currentAnimationId, onMarkerDeletionCalled, reloadMarkers, apiClient, deleteReplyMarker, avatarUrl,
      isShowDrawComponent, isOpenNouislider, updateIsOpenNouislider, showPeriodRangeProp,
      is_project_owner_member,
    } = this.props;
    const {
      currentX, currentY, currentWidth, currentHeight, currentShape, shouldShowForm,
      currentTime, markersVisibility, isMarking, isLargeScreen, isShowControlBar, isLoading,
      loadingText, isShowModalNotCompareVersion, showPeriodRange, commentNumber
    } = this.state;
    this.setShowPeriodRangeFromProp(showPeriodRangeProp);

    const src2 = this.YouTubeGetID(src)
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: mobile ? 0 : 1,
        mute: mobile ? 0 : 1,
        controls: 0,
        fs: 1,
        playsinline: 1,
      },
    };
    return (
      <div className={mobile ? 'wrap-animation-preview-for-mobile-video' : ''}>
        <div id="wrap-center"
        className={`wrap-animation-preview ${getStyleOfSize(scaleImage,"wrap")}`}
        style={{minHeight:"100%", position:'relative'}}
        >
          <Loadable
            className="loading-overlay"
            active={isLoading}
            text={loadingText || 'Now loading...'}
            zIndex={10000}
          >
          <div

              id="animation-player"
              style={{ width: `${scaleImage}%` }}
              className={classnames("animation-player", { marking: isMarking },{'d-table mt-auto mb-auto':scaleImage && scaleImage <100})}
              ref={this.refCallback}
              onMouseEnter={this.showSeekBar}
              onMouseLeave={this.hintSeekBar}
            >
              <canvas
                id="canvas"
                ref={(ref) => (this.canvas = ref)}
                width={`${this.state.canvasWidth}px`}
                height={`${this.state.canvasHeight}px`}
                style={Object.assign({}, styles.canvas, {
                  zIndex: this.state.zIndexSvg,
                })}
              ></canvas>

              <div
                ref={(ref) => (this.drawSvg = ref)}
                className="draw-svg"
                id="draw-svg"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: this.state.zIndexSvg,
                  pointerEvents: (this.props.isShowDrawComponent && this.props.isCommentMode) ? 'auto' : 'none',
                  touchAction: 'none',
                }}
                onMouseDown={(event) => this.onMouseDown(event, false)}
                onMouseMove={(event) => this.onMouseMove(event, true)}
                onMouseUp={(event) => this.onMouseUp(event, false)}
                onMouseLeave={() => this.onMouseUp()}
                onTouchStart={(event) => this.onMouseDown(event, true)}
                onTouchEnd={() => this.onMouseUp()}
                onTouchMove={(event) => this.onMouseMove(event, false)}
              >
                <svg
                  viewBox={`0 0 ${this.state.canvasWidth} ${this.state.canvasHeight}`}
                  className={
                    this.state.isDel
                      ? "cursor_eraser"
                      : `cursor_pencil_${this.state.settingDraw.color}`
                  }
                  width={`${this.state.canvasWidth}px`}
                  height={`${this.state.canvasHeight}px`}
                  ref={(ref) => (this.svg = ref)}
                  style={Object.assign({}, styles.canvas, {
                    left: 0,
                    zIndex: this.state.zIndexSvg,
                  })}
                >
                  {this.state.listItemSvg.map((item, i) => (
                    <PolyLineSvg
                      id={item.id}
                      points={item.points}
                      color={item.color}
                      lineWidth={item.lineWidth}
                      onItemMouseOver={(event) => this.onItemMouseOver(event)}
                      onItemMouseLeave={(event) => this.onItemMouseLeave(event)}
                      onDelete={(event) => this.onDelete(event)}
                    />
                  ))}
                </svg>
              </div>
              {src2 ? (
              <div style={{paddingTop: isLargeScreen ? 9/16 * 100 + '%' : "auto"}}
                  className='video-embed custom-youtube-player'
                  id="iframe-show-video"
                  ref={(ref) => (this.playerContainerRef = ref)}>
                {<YouTube
                  ref={(ref) => (this.player = ref)}
                  videoId={src2} opts={opts} onReady={(event) => this.onReadyVideoEmbed(event)}
                  className="iframe-video-embed" id="id-iframe-video-embed"
                  onStateChange={(event) => this.changeStateEmbedVideo(event)}
                  crossOrigin="anonymous"
                />}
                {/* Custom YouTube Controls */}
                {this.state.player && (
                  <YouTubeControls 
                    key={`youtube-controls-${src2}-${currentAnimationId || ''}`}
                    player={this.state.player}
                    containerRef={this.playerContainerRef}
                    opts={opts}
                    onChangeFullscreen={this.onChangeFullscreen.bind(this)}
                    handlePlaybackRateChange={this.handlePlaybackRateChange.bind(this)}
                    mobile={mobile}
                    onBeforePlay={this.checkPenBeforeAction}
                  />
                )}
                {this.state.penConfirmModal && (
                  <div data-pen-confirm-modal="true" style={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                    background: 'rgba(0,0,0,0.6)', zIndex: 2147483647,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <div style={{
                      background: '#1a1a1a', color: '#fff', borderRadius: '16px',
                      boxShadow: '0 20px 48px rgba(0,0,0,.6)',
                      padding: '32px 28px 24px', maxWidth: '320px',
                      width: 'calc(100vw - 48px)', textAlign: 'center', fontFamily: 'sans-serif',
                    }}>
                      <p style={{ fontSize: '15px', lineHeight: 1.7, margin: '0 0 24px', fontWeight: 500, color: '#fff' }}>
                        ペン入力中です。<br />このまま閉じてもよろしいですか？
                      </p>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexDirection: 'column' }}>
                        <button onClick={this.penConfirmSave} style={{
                          padding: '10px 0', border: 'none', borderRadius: '10px',
                          background: '#2563eb', color: '#fff',
                          fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                          boxShadow: '0 4px 12px rgba(37,99,235,.4)',
                        }}>保存して閉じる</button>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={this.penConfirmDiscard} style={{
                            flex: 1, padding: '10px 0', border: 'none', borderRadius: '10px',
                            background: '#e60c11', color: '#fff',
                            fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(230,12,17,.4)',
                          }}>破棄して閉じる</button>
                          <button onClick={this.penConfirmCancel} style={{
                            flex: 1, padding: '10px 0', border: 'none', borderRadius: '10px',
                            background: 'rgba(255,255,255,.12)', color: '#fff',
                            fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                          }}>キャンセル</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {
                  markerCreatable && this.renderOverlay()
                }
                {
                  isMarking && !is_show_draw_component && <MarkShape x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape} isCommentPeriod={isOpenNouislider} />
                }
                {
                  !this.state.isMobileFullScreen && (
                    <AnimationMarkersInPlayer
                      markers={this.activeMarkers()}
                      visibility={markersVisibility}
                      order={11}
                      onMarkerUpdationCalled={onMarkerUpdationCalled}
                      image={this.player}
                      updateMakerShow={updateMakerShow}
                    />
                  )
                }
                {
                  shouldShowForm && (
                    <AnimationMarkerForm
                      ref={(ref) => (this.makerForm = ref)}
                      x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape}
                      time={currentTime} onSubmit={this.onSubmitMarkerForm}
                      onClickClose={this.closeAnimationMarkerForm} order={12}
                      mobile={mobile} shouldShowForm={shouldShowForm} currentUserId={currentUserId}
                      role={role} owner={owner} user={user}
                      scaleImage={scaleImage}
                      captureVideoYoutube={this.captureVideoYoutube.bind(this)}
                      is_embed_video={true}
                      canvas={this.canvas}
                      is_show_draw_component={is_show_draw_component}
                      onlyBUAForCommentPeriod={isOpenNouislider}
                    />
                  )
                }
                
                <Shortcut ref="shortcut" />
              </div>
              ) : (
                <div style={{paddingTop: isLargeScreen ? 9/16 * 100 + '%' : "auto"}}
                  className='video-embed'
                  id="iframe-show-video">
                  {currentAnimation.title}バージョンのURLは削除されました。
                </div>
              ) }
          </div>
          </Loadable>
          <CommentDetail
            selectedMarker={this.props.selectedMarker}
            updateSelectedMarker={this.props.updateSelectedMarker}
            onMarkerUpdationCalled={onMarkerUpdationCalled}
            currentUserId={currentUserId}
            owner={owner}
            role={role}
            animationSelectCurrent={animationSelectCurrent}
            currentAnimationId={currentAnimationId}
            onMarkerDeletionCalled={onMarkerDeletionCalled}
            reloadMarkers={reloadMarkers}
            apiClient={apiClient}
            markers={markers}
            deleteReplyMarker={deleteReplyMarker}
            avatarUrl={avatarUrl}
            shouldShowForm={shouldShowForm}
            is_project_owner_member={is_project_owner_member}
          />
          <div ref={nodeModalVersion => { this.nodeModalVersion = nodeModalVersion }}>
            <Modal isOpen={isShowModalNotCompareVersion}
                className="animation-uploader-modal modal-dialog-centered modal-not-compare-version"
                size="md" >
              <ModalBody>
                <div className='text-center text-black'>
                  <div className='font-size-17px font-weight-bold text-black text-center'>
                    <span>メディア画面とコメントツールの </span>
                    <span>バージョンが異なる為、赤入れできません。</span>
                  </div>
                  <Button className="btn btn-danger my-2 button-set-current-animation" onClick={this.fetchCurrentAnimation}>
                    表示中のメディア画面を赤入れする
                  </Button>
                  <span>
                    ※クリックするとコメントツールのバージョンが{currentAnimation.final ? '最終稿' : currentAnimation.title}に変わります。
                  </span>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <div className="comment-timeline-container"
        style={{paddingTop:"10px"}}>
          <AnimationMarkerLine markers={markers}
            duration={this.state.totalDuration}
            player={this.state.player}
            isEmbedVideo={true}
            order={10}
            isShowDrawComponent={isShowDrawComponent}
            setPeriodRangeWhenClickTimeLine={this.setPeriodRangeWhenClickTimeLine}
            onMarkerLineClicked={this.props.onMarkerLineClicked}
          />
          <AnimationMarkerPeriod
            duration={this.state.totalDuration}
            player={this.state.player}
            isEmbedVideo={true}
            openPeriodCommentBox={this.openPeriod}
            isOpenNouislider={isOpenNouislider}
            updateIsOpenNouislider={updateIsOpenNouislider}
            showPeriodRange={showPeriodRange}
            commentNumber={commentNumber}
            onMarkerPeriodChanged={this.props.onMarkerPeriodChanged}
            commentPeriodContainer={this.props.commentPeriodContainer}
          ></AnimationMarkerPeriod>
        </div>
      </div>
    )
  }
}
